import { render, staticRenderFns } from "./AgencyDashboard.vue?vue&type=template&id=52d79ac4&scoped=true"
import script from "./AgencyDashboard.vue?vue&type=script&lang=js"
export * from "./AgencyDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgencyDashboard.vue?vue&type=style&index=0&id=52d79ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d79ac4",
  null
  
)

export default component.exports